import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { MdDialog, MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { NewDiseasePopupComponent } from './new-disease-popup.component';
import { DialogService } from './../../../shared/services/dialog.service';
import { SelectDiseaseService } from './select-disease.service';
import { AppMessages } from '../../../shared/constants/messages';
import { AppConstants } from '../../../shared/constants/constants';
import { Page } from '../../../models/list/page.model';
import { DiseaseModel } from '../../../models/consultation-process/disease.model';
import { ConsultationStep } from '../../../models/consultation/consultation.model';
import { ConsultationProcessService } from '../consultation-process.service';
import { BaseConsultationComponent } from '../base-consultation/base-consultation.component';
import { SharedService } from '../../../shared/services/share.services';

@Component({
  selector: 'select-disease',
  templateUrl: 'select-disease.component.html',
  providers: [SelectDiseaseService]
})

export class SelectDiseaseComponent extends BaseConsultationComponent implements OnInit, OnDestroy {
  public appConstants = AppConstants;
  public isGroupConsultation = true;
  public isMoveToPrescription = true;
  public page = new Page();
  public dataRow = new Array<DiseaseModel>();
  public attrArr = ['isCovered', 'isAccept', 'isDecideAgainst'];
  public dataMessage = {
    emptyMessage: AppMessages.list.noRecord, // Message to show when array is presented but contains no values
    totalMessage: AppMessages.list.total // Footer total message
  };

  public customClasses = AppConstants.table.footerClasses;

  constructor(public dialogService: DialogService,
    public consultationProcessService: ConsultationProcessService,
    public router: Router,
    public activeRouter: ActivatedRoute,
    private sharedService: SharedService,
    private selectDiseaseService: SelectDiseaseService) {
    super(dialogService, consultationProcessService, router, activeRouter, ConsultationStep.SelectVaccination);
    // get menu toggle action from shareService
    this.menuSubscription = this.sharedService.getMenuToggle().subscribe(
      data => {
        this.updateTableLayout();
      });
  }

  ngOnInit() {
    this.selectDiseaseService.checkConsultationGroup(this.filterParam.id).subscribe(
      (result) => {
        if (result) {
          const data = result.json();
          this.isGroupConsultation = data.status;
        }
      }
    );

    this.initTripInfo();
    this.setPage({ offset: 0 });
  }

  ngOnDestroy() {
    // unsubscribe to ensure no memory leaks
    this.subscription.unsubscribe();
  }

  setPage(pageInfo) {
    this.page.pageNumber = pageInfo.offset;
    this.selectDiseaseService.getDiseaseList(this.filterParam.id).subscribe(
      (result) => {
        if (result) {
          this.dataRow = result.json();
        }
      }
    );
  }

  /*  changeAlphabeticalOrder() {
     let temp = this.dataRow.sort(function(a, b) {
       return a.name.localeCompare(b.name);
     });
     this.dataRow = temp;
   } */

  onAddNewDiseaseDialog() {
    const data = {
      consultationId: this.filterParam.id
    };

    this.dialogService.openComponentDialog(NewDiseasePopupComponent, data, {
      width: '450px', position:
        { top: this.getTopPosition() + 'px' }
    }).subscribe(result => {
      if (result) {
        this.selectDiseaseService.addDisease(data.consultationId, result).subscribe(
          (result) => {
            if (result) {
              this.dataRow = this.dataRow.concat(result.json());
            }
          }
        );
      }
    });
  }

  onRemoveItem(row) {
    this.dialogService.openConfirmationDialog({ message: AppMessages.processConsultant.removeDisease }).subscribe(result => {
      if (result) {
        // remove user
        this.selectDiseaseService.removeDisease(this.filterParam.id, row.id).subscribe(
          (result) => {
            const index = this.dataRow.indexOf(row);
            this.dataRow.splice(index, 1);
          }
        );
      }
    });
  }

  onCheckAttr(item, attrName) {
    for (let i = 0; i < this.attrArr.length; i++) {
      if (this.attrArr[i] === attrName) {
        item[this.attrArr[i]] = true;
      } else {
        item[this.attrArr[i]] = false;
      }
    }
  }

  isValidData() {
    // Each disease is required to select one of these options “Covered”, “Accept”, “Decided Against”.
    // Otherwise system displays error message
    for (let i = 0; i < this.dataRow.length; i++) {
      if (this.dataRow[i].isVaccineCovered === false && this.dataRow[i].isAccept === false
        && this.dataRow[i].isCovered === false && this.dataRow[i].isDecideAgainst === false) {
        this.dialogService.openErrorDialog({ message: AppMessages.disease.errorSelectData });
        return false;
      } else if (this.dataRow[i].isAccept === true) {
        this.isMoveToPrescription = false;
      }
    }
    return true;
  }

  /**
   * over write from BaseConsultationComponent
   * submit step data
   */
  submitData() {
    if (!this.isMoveNextStep && !this.fromSelectDisease) {
      this.navigateAction();
    } else if (this.isValidData()) {
      // call API to submit
      this.selectDiseaseService.updateDisease(this.filterParam.id, this.dataRow, this.isMoveNextStep).subscribe(
        (result) => {
          // move to another step
          this.navigateAction();
        });
    }
  }


  /**
   * over write from BaseConsultationComponent
   * redirect to another step in consultation
   */
  navigateAction() {
    if (this.filterParam.patientId) {
      // Move to Prescribe vaccination(s) page when selecting at least 1 disease. Otherwise display Select prescription(s) page
      if (this.isMoveToPrescription === true && this.isMoveNextStep === true) {
        this.router.navigate(['consultation-process/select-prescriptions', this.filterParam.id, this.filterParam.patientId]);
      } else {
        this.router.navigate([this.navigateUrl, this.filterParam.id, this.filterParam.patientId]);
      }
    } else {
      this.router.navigate([this.navigateUrl, this.filterParam.id]);
    }
  }

  /**
     * over write from BaseConsultationComponent
     * this function will be called when user click on breakscrum step or next, prev button
     */
  changeConsultationStep() {
    this.submitData();
  }

  getCellClass({ row, column, value }) {
    return {
      'text-right': column['prop'] === 'disease'
    };
  }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation-process/select-disease/select-disease.component.ts